import CastForEducationIcon from '@material-ui/icons/CastForEducation';
export const OutreachIcon = CastForEducationIcon;